import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import auth from './auth'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '/',
          name: 'home',
          component: () => import(/* webpackChunkName: "welcome" */ './views/Welcome.vue')
        },
        {
          path: '/registrations',
          component: () => import(/* webpackChunkName: "registration" */ './views/registration/RegistrationIndex'),
          children: [
            {
              path: '/',
              name: 'registrations',
              component: () => import(/* webpackChunkName: "registration" */ './views/registration/Registrations.vue')
            },
            {
              path: 'new',
              name: 'new-registration',
              component: () => import(/* webpackChunkName: "registration" */ './views/registration/NewRegistration.vue')
            }
          ]
        },
        {
          path: '/users',
          component: () => import(/* webpackChunkName: "users" */ './views/user/UserIndex.vue'),
          children: [
            {
              path: '/',
              name: 'users',
              component: () => import(/* webpackChunkName: "users" */ './views/user/Users.vue')
            },
            {
              path: 'new',
              name: 'new-user',
              component: () => import(/* webpackChunkName: "users" */ './views/user/NewUser.vue')
            }
          ]
        }
      ]
    },
    {
      path: '/callback',
      name: 'callback',
      component: () => import(/* webpackChunkName: "auth" */ './views/Callback.vue'),
      meta: { anonymous: true }
    },
    {
      path: '/silent',
      name: 'silent',
      component: () => import(/* webpackChunkName: "auth" */ './views/Silent.vue'),
      meta: { anonymous: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.anonymous) {
    next()
    return
  }

  auth
    .checkIsLoggedIn()
    .then(() => { next() })
    .catch(() => { auth.login() })
})

export default router
